import * as React from 'react';
import Slider from 'react-slick';

import { ISimilarProduct } from '../../components/SimilarProducts/SimilarProducts';
import { ClassName } from '../../utils/utils';
import { ProductBox, ProductBoxNews } from '../modules';
import CountryService from '../../services/CountryService';

const sliderSettings: any = {
  dots: false,
  arrows: true,
  infinite: false,
  speed: 500,
  slidesToScroll: 1,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2
      }
    }
  ]
};

interface IVariantSliderProps {
  variants: Array<GQL.IProductVariant>;
  productTags: Array<GQL.IProductTag>;
  hideFavorite?: boolean;
  GTMItemListName?: string;
  disableArrows?: true;
}

const VariantSlider = (props: IVariantSliderProps) => {
  const { language } = CountryService.GetInstance();
  const { variants, productTags, GTMItemListName, disableArrows } = props;

  const boxType = 'buy';

  return (
    <Slider
      className={'variant-slider'}
      {...sliderSettings}
      arrows={'boolean' === typeof disableArrows ? !disableArrows : sliderSettings.arrows}
    >
      {variants.map((variant: GQL.IProductVariant, i) => {
        return (
          <div key={i} className="productList__item">
            <ProductBox
              language={language}
              // isFavorite={favorites.favorites.some(
              //   (v: GQL.IProductVariant) =>
              //     v.id == variant.id
              // )}
              // category={category}
              // sizes={getAllSizesForVariant(
              //   variant.product.id,
              //   variant,
              //   allProducts,
              //   attributes.attributes.filter(({ tags }: any) => tags.includes('size')),
              //   language,
              //   selectedSubOptions
              // )}
              tags={productTags}
              // hideTags={hideTags}
              // onToggleFavorite={async vId => {
              //   await this.toggleFavorite(vId);
              //   await favorites.refetch();
              // }}
              variant={variant}
              boxType={boxType}
              GTMItemListName={GTMItemListName}
            />
          </div>
        );
      })}
    </Slider>
  );
};

export default VariantSlider;



// WEBPACK FOOTER //
// ./src/modules/VariantSlider/VariantSlider.tsx